"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jstDate = exports.JST_OFFSET_MS = exports.isYahooImageKey = exports.YAHOO_IMAGE_PREFIX = exports.isYahooAnalyst = exports.isHttpsUrl = exports.DEFAULT_YAHOO_ANALYST = exports.YahooArticleStatus = void 0;
// A report written for Yahoo!ファイナンス (user, 2026-10-16): one article per
// company per day, which is also the file Yahoo receives
// ({ticker}-{YYYYMMDD}-article.xml). Re-sending a corrected article raises its
// RevisionId; LINE Yahoo is paid per article, so a second article for the same
// ticker on the same day does not happen (Ioller-san, 2026-10-16).
var YahooArticleStatus;
(function (YahooArticleStatus) {
    YahooArticleStatus["DRAFT"] = "DRAFT";
})(YahooArticleStatus || (exports.YahooArticleStatus = YahooArticleStatus = {}));
exports.DEFAULT_YAHOO_ANALYST = { name: '株式会社シェアードリサーチ', affiliation: 'アナリストチーム' };
const optionalString = (value) => value === undefined || typeof value === 'string';
// Only an https URL may become a link or an image (a javascript: or data: URL
// saved by one author must never run in another's browser).
const isHttpsUrl = (value) => {
    try {
        return new URL(value).protocol === 'https:';
    }
    catch {
        return false;
    }
};
exports.isHttpsUrl = isHttpsUrl;
const isYahooAnalyst = (value) => {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return false;
    const v = value;
    const known = ['name', 'affiliation', 'description', 'imageUrl'];
    return (Object.keys(v).every((key) => known.includes(key)) &&
        typeof v.name === 'string' &&
        v.name.trim() !== '' &&
        typeof v.affiliation === 'string' &&
        v.affiliation.trim() !== '' &&
        optionalString(v.description) &&
        (v.imageUrl === undefined || (typeof v.imageUrl === 'string' && (v.imageUrl === '' || (0, exports.isHttpsUrl)(v.imageUrl)))));
};
exports.isYahooAnalyst = isYahooAnalyst;
// Images live in our storage until sending (phase 2 publishes them); a block
// keeps the storage key, and the XML src is YAHOO_IMAGE_BASE_URL + key.
exports.YAHOO_IMAGE_PREFIX = 'yahoo/img/';
const isYahooImageKey = (key) => /^yahoo\/img\/[0-9a-f]{64}\.(png|jpg|webp)$/.test(key);
exports.isYahooImageKey = isYahooImageKey;
exports.JST_OFFSET_MS = 9 * 60 * 60 * 1000;
const jstDate = (date) => new Date(date.getTime() + exports.JST_OFFSET_MS).toISOString().slice(0, 10);
exports.jstDate = jstDate;
